import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eae31776"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_create_app",
  ref: "refModalCreateAppraisal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header pt-8 pb-5 px-10" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title fs-1 fw-bold" }, "Nuevo avalúo", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-circle text-white fs-2" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body py-lg-3 px-10" }
const _hoisted_9 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-lg-row py-5",
  id: "kt_modal_create_app_stepper",
  ref: "createAppRef"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-row-auto w-100 w-lg-300px\" data-v-eae31776><div class=\"stepper-nav\" data-v-eae31776><div class=\"stepper-item me-5 current\" data-kt-stepper-element=\"nav\" data-v-eae31776><div class=\"stepper-line w-40px\" data-v-eae31776></div><div class=\"stepper-icon w-40px h-40px\" data-v-eae31776><i class=\"stepper-check fas fa-check\" data-v-eae31776></i><span class=\"stepper-number\" data-v-eae31776>1</span></div><div class=\"stepper-label\" data-v-eae31776><h3 class=\"stepper-title\" data-v-eae31776>Cliente</h3><div class=\"stepper-desc\" data-v-eae31776>Información</div></div></div><div class=\"stepper-item me-5\" data-kt-stepper-element=\"nav\" data-v-eae31776><div class=\"stepper-line w-40px\" data-v-eae31776></div><div class=\"stepper-icon w-40px h-40px\" data-v-eae31776><i class=\"stepper-check fas fa-check\" data-v-eae31776></i><span class=\"stepper-number\" data-v-eae31776>2</span></div><div class=\"stepper-label\" data-v-eae31776><h3 class=\"stepper-title\" data-v-eae31776>Vehículo</h3><div class=\"stepper-desc\" data-v-eae31776>Detalles</div></div></div><div class=\"stepper-item me-5\" data-kt-stepper-element=\"nav\" data-v-eae31776><div class=\"stepper-line w-40px\" data-v-eae31776></div><div class=\"stepper-icon w-40px h-40px\" data-v-eae31776><i class=\"stepper-check fas fa-check\" data-v-eae31776></i><span class=\"stepper-number\" data-v-eae31776>3</span></div><div class=\"stepper-label\" data-v-eae31776><h3 class=\"stepper-title\" data-v-eae31776>Inspección</h3><div class=\"stepper-desc\" data-v-eae31776>Diagnóstico</div></div></div></div></div>", 1)
const _hoisted_11 = { class: "flex-row-fluid" }
const _hoisted_12 = {
  class: "form mx-auto",
  novalidate: "novalidate",
  id: "kt_modal_create_app_form"
}
const _hoisted_13 = {
  "data-kt-stepper-element": "content",
  class: "current"
}
const _hoisted_14 = { class: "w-100" }
const _hoisted_15 = { class: "fv-row mb-10" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tipo de avalúo")
], -1))
const _hoisted_17 = { class: "mt-3 d-flex" }
const _hoisted_18 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_19 = { class: "d-flex align-items-center ms-2" }
const _hoisted_20 = { class: "d-flex flex-column" }
const _hoisted_21 = { class: "fw500 fs-6" }
const _hoisted_22 = { class: "fv-row mb-10" }
const _hoisted_23 = { class: "d-flex flex-column mb-2" }
const _hoisted_24 = { class: "row g-9 mb-2" }
const _hoisted_25 = { class: "col-md-6 fv-row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Nombre")
], -1))
const _hoisted_27 = { class: "position-relative" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle-y top-50 start-0 ms-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    role: "button",
    class: "svg-icon svg-icon-1hx pointer"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "isax-user" })
  ])
], -1))
const _hoisted_29 = { class: "fv-plugins-message-container" }
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "col-md-6 fv-row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Apellidos")
], -1))
const _hoisted_33 = { class: "input-group mb-1" }
const _hoisted_34 = { class: "d-flex flex-column mb-2" }
const _hoisted_35 = { class: "fv-row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Correo electrónico")
], -1))
const _hoisted_37 = { class: "position-relative" }
const _hoisted_38 = { class: "position-absolute translate-middle-y top-50 start-0 ms-3" }
const _hoisted_39 = {
  role: "button",
  class: "svg-icon svg-icon-1hx pointer"
}
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "d-flex flex-column mb-2" }
const _hoisted_43 = { class: "fv-row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Teléfono")
], -1))
const _hoisted_45 = { class: "position-relative" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle-y top-50 start-0 ms-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    role: "button",
    class: "svg-icon svg-icon-1hx pointer"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "isax-call" })
  ])
], -1))
const _hoisted_47 = { "data-kt-stepper-element": "content" }
const _hoisted_48 = { class: "w-100" }
const _hoisted_49 = { class: "fv-row mb-10" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Marca")
], -1))
const _hoisted_51 = { class: "fv-row mb-10" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Modelo")
], -1))
const _hoisted_53 = { class: "fv-row mb-10" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Año")
], -1))
const _hoisted_55 = { class: "fv-row mb-10" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Version")
], -1))
const _hoisted_57 = { class: "fv-row mb-10" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Cantidad de dueños")
], -1))
const _hoisted_59 = { class: "fv-row mb-10" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Kilometraje del vehículo")
], -1))
const _hoisted_61 = { "data-kt-stepper-element": "content" }
const _hoisted_62 = { class: "w-100" }
const _hoisted_63 = { class: "fv-row mb-10" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Diagnóstico")
], -1))
const _hoisted_65 = { class: "borderDotted text-center" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { class: "contentDropZone" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_69 = { class: "lst-none mb-5" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mb-3" }, "Arrastra el archivo de diagnóstico")
], -1))
const _hoisted_71 = { class: "mb-3" }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { class: "d-flex flex-column p-2" }
const _hoisted_74 = { class: "d-flex flex-row justify-content-end" }
const _hoisted_75 = {
  type: "button",
  class: "btn btn-danger btn-sm btntrash-rounded",
  title: "Eliminar imagen"
}
const _hoisted_76 = { class: "d-flex flex-column justify-content-center align-items-center" }
const _hoisted_77 = { class: "lst-none mt-5" }
const _hoisted_78 = { class: "mb-3" }
const _hoisted_79 = { class: "text-center" }
const _hoisted_80 = {
  key: 0,
  class: "fv-plugins-message-container invalid-feedback",
  name: "inputFile"
}
const _hoisted_81 = { class: "d-flex flex-stack pt-10" }
const _hoisted_82 = {
  key: 0,
  class: "me-2"
}
const _hoisted_83 = { class: "me-2" }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = {
  key: 2,
  class: "indicator-progress"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loaderClientVue = _resolveComponent("loaderClientVue")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal())),
              class: "pointer"
            }, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_loaderClientVue, { showLoader: _ctx.loading }, null, 8, ["showLoader"]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("form", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types_appraisal, (types, index) => {
                            return (_openBlock(), _createElementBlock("label", {
                              class: "d-flex flex-stack me-5 cursor-pointer",
                              key: index
                            }, [
                              _createElementVNode("span", _hoisted_18, [
                                _createVNode(_component_Field, {
                                  class: "form-check-input",
                                  type: "radio",
                                  name: "type_appraisal",
                                  value: types.id,
                                  id: 'type-' + types.id,
                                  checked: "{{ types.active }}",
                                  onChange: ($event: any) => (_ctx.onChangeTypeAppraisal(types.id)),
                                  modelValue: _ctx.formData.type_appraisal,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.type_appraisal) = $event))
                                }, null, 8, ["value", "id", "onChange", "modelValue"])
                              ]),
                              _createElementVNode("span", _hoisted_19, [
                                _createElementVNode("span", _hoisted_20, [
                                  _createElementVNode("span", _hoisted_21, _toDisplayString(types.label), 1)
                                ])
                              ])
                            ]))
                          }), 128))
                        ]),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "type_appraisal"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _hoisted_26,
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(_component_Field, {
                                  type: "text",
                                  class: "form-control form-control-solid border-1 border-secondary ps-10",
                                  placeholder: "Luis Daniel",
                                  name: "firtsname",
                                  modelValue: _ctx.formData.firtsname,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.firtsname) = $event))
                                }, null, 8, ["modelValue"]),
                                _hoisted_28
                              ]),
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createVNode(_component_ErrorMessage, {
                                    class: "fv-plugins-message-container invalid-feedback",
                                    name: "firtsname"
                                  })
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _hoisted_32,
                              _createElementVNode("div", _hoisted_33, [
                                _createVNode(_component_Field, {
                                  type: "text",
                                  class: "form-control form-control-solid border-1 border-secondary ps-5",
                                  name: "lastname",
                                  placeholder: "Díaz",
                                  modelValue: _ctx.formData.lastname,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.lastname) = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_ErrorMessage, {
                                  class: "fv-plugins-message-container invalid-feedback",
                                  name: "lastname"
                                })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _hoisted_36,
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_Field, {
                                type: "text",
                                class: "form-control form-control-solid border-1 border-secondary ps-10",
                                placeholder: "example@mail.com",
                                name: "email",
                                modelValue: _ctx.formData.email,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.email) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("span", _hoisted_39, [
                                  _createVNode(_component_inline_svg, { src: "media/icons/iconsax/Correo.svg" })
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createVNode(_component_ErrorMessage, {
                                  class: "fv-plugins-message-container invalid-feedback",
                                  name: "email"
                                })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _hoisted_44,
                            _createElementVNode("div", _hoisted_45, [
                              _withDirectives(_createVNode(_component_Field, {
                                type: "text",
                                class: "form-control form-control-solid border-1 border-secondary ps-10",
                                placeholder: "333-333-3331",
                                name: "phone",
                                modelValue: _ctx.formData.phone,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.phone) = $event))
                              }, null, 8, ["modelValue"]), [
                                [_directive_maska, { mask:'Z##-###-####', tokens: { Z: { pattern: /[1-9]/ } }, }]
                              ]),
                              _hoisted_46
                            ]),
                            _createVNode(_component_ErrorMessage, {
                              class: "fv-plugins-message-container invalid-feedback",
                              name: "phone"
                            })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createVNode(_component_Field, {
                          name: "brand",
                          autocomplete: "off",
                          class: "form-select form-select-solid select2-hidden-accessible",
                          placeholder: "Selecciona una marca",
                          modelValue: _ctx.formData.brand.id,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.brand.id) = $event))
                        }, {
                          default: _withCtx(({ value, errorMessage, handleChange }) => [
                            _createVNode(_component_el_form_item, { error: errorMessage }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  class: "w-100",
                                  name: "brand",
                                  value: value,
                                  "model-value": _ctx.listBrands.filter(item => item?.id == value)[0]?.name,
                                  "onUpdate:modelValue": handleChange,
                                  placeholder: "Selecciona una marca",
                                  loading: _ctx.loading,
                                  size: "large",
                                  onChange: _cache[6] || (_cache[6] = ($event: any) => {_ctx.getModels(); _ctx.setBrand();}),
                                  disabled: _ctx.listBrands.length == 0
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listBrands, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: index,
                                        label: item.name,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "disabled"])
                              ]),
                              _: 2
                            }, 1032, ["error"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createVNode(_component_Field, {
                          name: "model",
                          autocomplete: "off",
                          class: "form-select form-select-solid select2-hidden-accessible",
                          placeholder: "Selecciona un modelo",
                          modelValue: _ctx.formData.model.id,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.model.id) = $event))
                        }, {
                          default: _withCtx(({ value, errorMessage, handleChange }) => [
                            _createVNode(_component_el_form_item, { error: errorMessage }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  name: "model",
                                  size: "large",
                                  class: "w-100",
                                  value: value,
                                  "model-value": _ctx.listModels.filter(item => item?.id == value)[0]?.name,
                                  "onUpdate:modelValue": handleChange,
                                  placeholder: "Selecciona un modelo",
                                  loading: _ctx.loading,
                                  onChange: _cache[8] || (_cache[8] = ($event: any) => {_ctx.getYears(); _ctx.setModel();}),
                                  disabled: _ctx.listModels.length == 0
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listModels, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: index,
                                        label: item.name,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "disabled"])
                              ]),
                              _: 2
                            }, 1032, ["error"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _createVNode(_component_Field, {
                          name: "year",
                          autocomplete: "off",
                          class: "form-select form-select-solid select2-hidden-accessible",
                          placeholder: "Selecciona un año",
                          modelValue: _ctx.formData.year.id,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.year.id) = $event))
                        }, {
                          default: _withCtx(({ value, errorMessage, handleChange }) => [
                            _createVNode(_component_el_form_item, { error: errorMessage }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  name: "year",
                                  size: "large",
                                  class: "w-100",
                                  value: value,
                                  "model-value": _ctx.listYears.filter(item => item?.id == value)[0]?.name,
                                  "onUpdate:modelValue": handleChange,
                                  placeholder: "Selecciona un año",
                                  loading: _ctx.loading,
                                  onChange: _cache[10] || (_cache[10] = ($event: any) => {_ctx.getVersions(); _ctx.setYear();}),
                                  disabled: _ctx.listYears.length == 0
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listYears, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: index,
                                        label: item.name,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "disabled"])
                              ]),
                              _: 2
                            }, 1032, ["error"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _hoisted_56,
                        _createVNode(_component_Field, {
                          name: "version",
                          autocomplete: "off",
                          class: "form-select form-select-solid select2-hidden-accessible w-100",
                          placeholder: "Selecciona una version",
                          modelValue: _ctx.formData.version.id,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.version.id) = $event))
                        }, {
                          default: _withCtx(({ value, errorMessage, handleChange }) => [
                            _createVNode(_component_el_form_item, { error: errorMessage }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  name: "version",
                                  size: "large",
                                  class: "w-100",
                                  value: value,
                                  "model-value": _ctx.listVersions.filter(item => item?.id == value)[0]?.name,
                                  "onUpdate:modelValue": handleChange,
                                  placeholder: "Selecciona una version",
                                  loading: _ctx.loading,
                                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setVersion())),
                                  disabled: _ctx.listVersions.length == 0
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listVersions, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: index,
                                        label: item.name,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "disabled"])
                              ]),
                              _: 2
                            }, 1032, ["error"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _hoisted_58,
                        _createVNode(_component_Field, {
                          name: "owners",
                          class: "form-select form-select-solid select2-hidden-accessible",
                          modelValue: _ctx.formData.owners,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.owners) = $event))
                        }, {
                          default: _withCtx(({ value, errorMessage, handleChange }) => [
                            _createVNode(_component_el_form_item, { error: errorMessage }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input_number, {
                                  value: value,
                                  class: "w-100 in-num",
                                  "model-value": value,
                                  "onUpdate:modelValue": handleChange,
                                  min: "1"
                                }, null, 8, ["value", "model-value", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["error"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _hoisted_60,
                        _createVNode(_component_Field, {
                          type: "text",
                          autocomplete: "off",
                          placeholder: "000,000",
                          class: "form-control form-control-solid border-1 border-secondary",
                          name: "mileage",
                          modelValue: _ctx.formData.mileage,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.mileage) = $event)),
                          onChange: _ctx.addKm
                        }, null, 8, ["modelValue", "onChange"]),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "mileage"
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _hoisted_64,
                        _createElementVNode("div", _hoisted_65, [
                          (!_ctx.fileload)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "file",
                                  accept: "image/jpeg,image/png,application/pdf",
                                  id: "inputFile",
                                  name: "inputFile",
                                  ref: "inputFile",
                                  onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.getFilesInput && _ctx.getFilesInput(...args)))
                                }, null, 544), [
                                  [_vShow, false]
                                ]),
                                _createElementVNode("div", {
                                  onDrop: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dropEvent && _ctx.dropEvent(...args)), ["prevent"])),
                                  onDragenter: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.checkData && _ctx.checkData(...args))),
                                  onDragover: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.checkData && _ctx.checkData(...args))),
                                  class: _normalizeClass( (_ctx.files.length == 0 && !_ctx.isEdit) || (_ctx.isEdit && _ctx.files.length == 0) ? 'dropZone dzBorder' : 'dropZoneAuto' )
                                }, [
                                  _withDirectives(_createElementVNode("div", _hoisted_67, [
                                    _createVNode(_component_inline_svg, {
                                      src: "media/icons/iconsax/document-text-1.svg",
                                      class: "mt-5 mb-3"
                                    }),
                                    _hoisted_68,
                                    _createElementVNode("ul", _hoisted_69, [
                                      _hoisted_70,
                                      _createElementVNode("li", null, [
                                        _createElementVNode("span", _hoisted_71, [
                                          _createTextVNode("o "),
                                          _createElementVNode("a", {
                                            href: "javascript:void(0)",
                                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.addImage && _ctx.addImage(...args)))
                                          }, "selecciónalo de una carpeta")
                                        ])
                                      ])
                                    ])
                                  ], 512), [
                                    [_vShow,  (_ctx.files.length == 0 && !_ctx.isEdit) || (_ctx.isEdit && _ctx.files.length == 0) ]
                                  ])
                                ], 34)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                _createElementVNode("div", _hoisted_73, [
                                  _createElementVNode("div", _hoisted_74, [
                                    _createElementVNode("button", _hoisted_75, [
                                      _createVNode(_component_inline_svg, {
                                        src: "media/icons/iconsax/trash.svg",
                                        class: "trashButton",
                                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.deleteImage(_ctx.index)))
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_76, [
                                    _createVNode(_component_inline_svg, {
                                      src: "media/icons/iconsax/document-text-1.svg",
                                      height: "70",
                                      width: "70",
                                      class: "mb-5"
                                    }),
                                    _createElementVNode("ul", _hoisted_77, [
                                      _createElementVNode("li", null, [
                                        _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.formData.diagnostic_file.name), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          (_ctx.error_file)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_80, "El archivo de diagnóstico es obligatorio"))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    (_ctx.currentStepIndex == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-lg btn-secondary me-3",
                            "data-kt-stepper-action": "close",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.closeModal()))
                          }, " Descartar ")
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-lg btn-secondary me-3",
                        "data-kt-stepper-action": "previous",
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.previousStep()))
                      }, " Regresar ")
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-lg btn-primary",
                        onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
                      }, [
                        (_ctx.currentStepIndex < 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_84, " Siguiente"))
                          : _createCommentVNode("", true),
                        (_ctx.currentStepIndex >= 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_85, " Crear avalúo"))
                          : _createCommentVNode("", true),
                        (_ctx.currentStepIndex >= 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_86, [
                              _createTextVNode(" Espera por favor... "),
                              _hoisted_87
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ], 512)
          ])
        ])
      ])
    ], 512)
  ]))
}